<template>
    <div class="form">

        <!-- options -->
        <div class="form__section">
            <div class="form__title">Kein Führerschein benötigt</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.noLicence" 
                        :options="noLicenceOptions"
                        :outputArray="true"
                        :tracking-data-label="'Sharing'"
                        :tracking-data-category="'Route Planner'"
                        @change="fieldChangeHandler($event, 'noLicence')"
                    />
                </div>
            </div>
        </div>

        <div class="form__section">
            <div class="form__title">Führerschein benötigt</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.licence" 
                        :options="licenceOptions"
                        :outputArray="true"
                        :tracking-data-label="'Sharing'"
                        :tracking-data-category="'Route Planner'"
                        @change="fieldChangeHandler($event, 'licence')"
                    />
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import settingsTabBlueprint from '@/mixins/settings-tab-blueprint';
import SmrChoiceGroup from '@/components/form/SmrChoiceGroup.vue'
import { NO_LICENCE_SHARING, LICENCE_SHARING } from '@/data/sharingMeansOfTransport'

export default {
    components: {
        SmrChoiceGroup,

    },
    mixins: [
        settingsTabBlueprint
    ],
    data() {
        return {
            data: {},
            noLicenceOptions: [...NO_LICENCE_SHARING],
            licenceOptions: [...LICENCE_SHARING],
        }
    },

}
</script>
